import React from "react"
import Layout from "../components/core/layout"
// import Pager from "../components/Features/pager"
import { graphql } from "gatsby"
import Post from "../components/post/post"
import SEO from "../components/Features/seo"
import slugify from "../utilty/utlityFunctions"
export default function SingleTagPage({ data, pageContext }) {
  // const { group, index, first, last, pageCount } = pageContext
  // const previousUrl = index - 1 === 1 ? "/" : (index - 1).toString()
  // const nextUrl = (index + 1).toString()
  const { tag } = pageContext
  const { totalCount } = data.allContentfulBlogPost
  const pageHeader = `${totalCount} post${
    totalCount === 1 ? "" : "s"
  } tagged with ${tag}`

  return (
    <Layout>
      {data.allContentfulBlogPost.edges.map(({ node }) => {
        return (
          <div key={node.title}>
            <h4> {pageHeader}</h4>
            <hr />
            <Post post={node} />
            <SEO
              title={`${node.tags} Tags All Posts`}
              tags={node.tags}
              slug={slugify(tag)}
            />
          </div>
        )
      })}
    </Layout>
  )
}

export const SingleTagPost = graphql`
  query($tag: String!) {
    allContentfulBlogPost(
      sort: { fields: [publishDate], order: DESC }
      filter: { tags: { in: [$tag] } }
    ) {
      totalCount
      edges {
        node {
          author {
            name
          }
          category {
            title
            description
          }
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          tags
          heroImage {
            fluid(resizingBehavior: SCALE, maxHeight: 196, maxWidth: 350) {
              ...GatsbyContentfulFluid
              base64
              # tracedSVG
              srcWebp
              srcSetWebp
            }
          }
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`
